import { Link } from "react-router-dom";
import logoimg from "../assets/images/logo.png";

function Footer() {
  return (
    <>
      <div className="footer-banner-bottom">
        <div className="footer-inner">
          <h2>Follow us for latest updates</h2>

          <div className="footer-banner-icons">
            {/* FACEBOOK */}
            <a
              href="https://www.facebook.com/swiftintelli"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src="https://cdn-icons-png.flaticon.com/512/733/733547.png"
                alt="Facebook"
              />
            </a>

            {/* INSTAGRAM */}
            <a
              href="https://www.instagram.com/swiftintelli/"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src="https://cdn-icons-png.flaticon.com/512/2111/2111463.png"
                alt="Instagram"
              />
            </a>

            {/* YOUTUBE */}
            <a
              href="https://www.youtube.com/@SWIFTINTELLI"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src="https://cdn-icons-png.flaticon.com/512/1384/1384060.png"
                alt="YouTube"
              />
            </a>

            {/* WHATSAPP */}
            {/* LINKEDIN */}
            <a
              href="https://www.linkedin.com/company/swiftintelli/"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/c/ca/LinkedIn_logo_initials.png"
                alt="LinkedIn"
              />
            </a>
          </div>
        </div>
      </div>
      <footer className="si-footer">
        <div className="si-footer-top">
          {/* BRAND */}
          <div className="si-footer-brand">
            <img src={logoimg} alt="SwiftIntelli Logo" className="si-logo" />

            <p>
              Empowering the next generation of tech professionals through
              immersive, project-driven learning experiences.
            </p>
          </div>

          {/* NAVIGATE */}
          <div className="si-footer-col">
            <h4>NAVIGATE</h4>

            {[
              ["/about", "About"],
              ["/whyus", "Why SWIFTIntelli"],
              ["/courses", "Courses"],
              ["/contact-us", "Contact"],
            ].map(([h, l]) => (
              <Link key={l} to={h}>
                {l}
              </Link>
            ))}
          </div>

          <div className="si-footer-col">
            <h4>COURSES</h4>

            <Link to="/courses">AI/ML with Applied Gen-AI</Link>
            <Link to="/courses">Prompt Engineering & Applied Gen-AI</Link>
            <p className="si-footer-disabled">IoT Systems (UpComing)</p>

            <p className="si-footer-disabled">Robotics (UpComing)</p>
          </div>

          <div className="si-footer-col">
            <h4>Important Links</h4>

            <Link to="/privacy-policy">Privacy Policy</Link>

            <Link to="/terms-and-conditions">Terms & Conditions</Link>
          </div>
        </div>{" "}
        {/* si-footer-top */}
        {/* BOTTOM */}
        <div className="si-footer-bottom">
          <span>© 2026 SWIFTIntelli. All rights reserved.</span>

          {/* <span>Privacy Policy · Terms of Service</span> */}
        </div>
        {/* WHATSAPP FLOAT */}
        {/* WHATSAPP FLOAT */}
        <Link
          to="https://wa.me/919391966251"
          className="whatsapp-float"
          target="_blank"
          rel="noreferrer"
        >
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
            alt="WhatsApp"
          />
        </Link>
      </footer>
    </>
  );
}

export default Footer;
